import { render, staticRenderFns } from "./AdditionalManagers.vue?vue&type=template&id=26fa0331&scoped=true&"
import script from "./AdditionalManagers.vue?vue&type=script&lang=ts&"
export * from "./AdditionalManagers.vue?vue&type=script&lang=ts&"
import style0 from "./AdditionalManagers.vue?vue&type=style&index=0&id=26fa0331&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26fa0331",
  null
  
)

export default component.exports